import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-three-state-toggle',
    templateUrl: './three-state-toggle.component.html',
    styleUrls: ['./three-state-toggle.component.less']
})
export class ThreeStateToggleComponent implements OnInit {
    // Input to allow setting the initial state from the parent
    @Input() currentValue = 1; // 0 = Not Included, 1 = All, 2 = Included

    // Output to emit the new state when toggled
    @Output() stateChange = new EventEmitter<number>();

    indicatorPosition = '100px'; // Default for "All"

    // Function to handle toggling between states
    toggleState(): void {
        this.currentValue = (this.currentValue + 1) % 3; // Rotate between 0, 1, 2
        //this.stateChange.emit(this.currentValue); // Emit the updated state

        this.updateIndicatorPosition(this.currentValue);
    }

    ngOnInit(): void {
        this.updateIndicatorPosition(this.currentValue);
    }

    private updateIndicatorPosition(value: number): void {
        if (value === 0) {
            this.indicatorPosition = '0px'; // Leftmost for "Not Included"
        } else if (value === 1) {
            this.indicatorPosition = '100px'; // Center for "All"
        } else if (value === 2) {
            this.indicatorPosition = '200px'; // Rightmost for "Included"
        }

        this.stateChange.emit(value); // Emit the updated state
    }
}
